module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h2', [_vm._v("Overview of the first page of your appeal")]), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin": "32px 0px"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "block"
    }
  }, [_c('canvas', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageRendered),
      expression: "pageRendered"
    }],
    staticStyle: {
      "border": "1px solid #ddd"
    },
    attrs: {
      "id": "pdfcanvas"
    }
  })]), _vm._v(" "), (!_vm.pageRendered) ? _c('div', {
    staticStyle: {
      "max-width": "300px",
      "border": "1px solid #ddd",
      "border-radius": "2px",
      "padding": "16px 32px",
      "text-align": "center",
      "margin": "16px"
    }
  }, [_vm._v(" \n      Please wait, we are making the overview of your appeal.\n      "), _c('br'), _vm._v(" "), _c('i', {
    staticClass: "fa fa-gear fa-spin",
    staticStyle: {
      "font-size": "32px",
      "margin-top": "16px",
      "color": "#888"
    }
  })]) : _vm._e()]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "centered-child",
    staticStyle: {
      "margin-top": "48px"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary large-button",
    on: {
      "click": function($event) {
        return _vm.onContinue()
      }
    }
  }, [_vm._v("Continue")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("\n    The document represents "), _c('u', [_vm._v("a draft")]), _vm._v(" of your appeal.\n    Your "), _c('u', [_vm._v(" final ")]), _vm._v(" appeal will be sent to the administration once the file is completely done.\n    ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-de7efc8e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/screens/CheckoutPreview.vue
// module id = 744
// module chunks = 3